export enum MatTablePaginationDirection {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
}
